import React from 'react';
import { GenericNotificationPage } from '../genericNotificationPage/genericNotificationPage';

export const RotateScreen = (): JSX.Element => {
  return (
    <GenericNotificationPage
      title="Please rotate your screen to continue."
      iconUrl="assets/bigBangLab/rotate-screen.png"
    />
  );
};
